<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(services) => offerSectionSet({serviceCards: services})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.serviceCards" v-html="offerSections.serviceCards"></div>
        <div v-else class="services">
            <h3>{{ $t('serviceCards.heading') }}</h3>
            <b-row>
                <b-col 
                    md="4" 
                    class="mb-4"
                    :key="index" 
                    v-for="(service, index) in services"
                >
                    <b-card :class="{ 'azubi-card': service.isAzubi }">
                        <h5><i class="material-icons service-icon">check_circle</i>{{service.label}}</h5>
                        <p>
                            {{service.description}}<template v-if="service.href"><br><a
                                :href="service.href"
                                class="d-inline-block mt-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            ><strong>{{service.linkText}}</strong></a></template>
                        </p>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: "ServiceCards",
  props: {
    options: Object,
  },
  computed: {
    ...mapGetters(["offerType", "offerSections", "offer"]),
    services: function () {
      let serviceKeys;
      if (this.offer && this.offer.offerType_id === 4) {
        serviceKeys = this.offer.isRemote
          ? ["freeConsultingOpen", "cancellationOpen", "noPrepayment", "azubi"]
          : [
              "hotel",
              "parking",
              "noPrepayment",
              "shuttle",
              "catering",
              "azubi",
            ];
      } else if (
        this.offer &&
        (parseInt(this.offer.isRemote) === 1 ||
          (this.offerType && [1, 3].includes(this.offerType.id)))
      ) {
        serviceKeys = [
          "flexibleScheduling",
          "freeConsultingInhouse",
          "cancellationInhouse",
          "noPrepayment",
          "azubi",
        ];
      } else if (this.offerType) {
        serviceKeys = ['hotel', 'parking', 'noPrepayment', 'shuttle', 'catering', 'azubi'];
      } else {
        serviceKeys = [];
      }
      return serviceKeys.map((key) => ({
        label: this.$t(`serviceCards.${this.labelKey(key)}`),
        description: this.$t(`serviceCards.${key}`),
        href: key === 'azubi' ? 'https://www.gfu.net/?azubi' : null,
        linkText: key === 'azubi' ? this.$t('serviceCards.azubiLinkText') : null,
        isAzubi: key === 'azubi',
      }));
    },
  },
  data: function () {
    return {
      renderKey: 0,
    };
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
    labelKey(key) {
      const labels = {
        freeConsultingOpen: 'freeConsultingLabel', freeConsultingInhouse: 'freeConsultingLabel',
        cancellationOpen: 'cancellationLabel', cancellationInhouse: 'cancellationLabel',
        noPrepayment: 'noPrepaymentLabel', hotel: 'hotelLabel', parking: 'parkingLabel',
        shuttle: 'shuttleLabel', catering: 'cateringLabel', flexibleScheduling: 'flexibleSchedulingLabel',
        azubi: 'azubiLabel',
      };
      return labels[key];
    },
  },
  watch: {
    offerType: function () {
      this.renderKey++;
    },
  },
};
</script>

<style scoped>
.azubi-card {
  height: 100%;
  border: none;
  background-color: rgb(220, 238, 235, 0.6);
}
</style>
